import { useCallback } from 'react';
import { nanoid } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { billingRequestStarted, billingResponseReceived } from '../store/billingCacheSlice';

/** undefined disables private reads while authentication is pending; null is public. */
export function useBillingCache<T>(ownerId: string | null | undefined, key: string) {
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => ownerId !== undefined && state.billingCache?.ownerId === ownerId
    ? state.billingCache.entries[key]?.data as T | undefined : undefined);
  const beginRequest = useCallback(() => {
    const request = { ownerId: ownerId ?? null, key, requestId: nanoid() };
    if (ownerId !== undefined) dispatch(billingRequestStarted(request));
    return (value: T) => {
      if (ownerId !== undefined) dispatch(billingResponseReceived({ ...request, data: value }));
    };
  }, [dispatch, ownerId, key]);
  return { data, beginRequest };
}
